
import { put, takeEvery } from 'redux-saga/effects'

import { INIT_PROJECT } from '../../map/sagas';

export const SET_PROJECT = 'project/SET_PROJECT';
export const SET_PROJECT_PARAM = 'project/SET_PROJECT_PARAM';

export default function getActions(dispatch) {
    return {
        setProject: (project) => dispatch({
            type: SET_PROJECT, project
        }),
        setProjectParam: (name, value) => dispatch({
            type: SET_PROJECT_PARAM, name, value
        })
   }
}

function* workSetProject(action) {
    yield put({type: INIT_PROJECT, mapProject: action.project.mapProject});
}

export function* watchSetProject() {
    yield takeEvery(SET_PROJECT, workSetProject)
}
